import angular from 'angular';

import component from './cvt-dashboard-header.component';

const CvtDashboardHeader = angular
    .module('control-room.internal.components.cvt.components.cvt-dashboard.components.cvt-dashboard.header', [])
    .component('crCvtDashboardHeader', component);

export default CvtDashboardHeader;
